<template>
	<div class="announcement-overview">
		<div class="rs-o-surf-container rs-o-surf-module-section">
			<OverviewModuleTitle :name="name" />

			<SurfStateBox :loading="loading" :completed="completed" :empty="isEmpty">
				<div class="rs-o-surf-overview-root">
					<div class="overview-group">
						<SurfInlineTwoTextStyle1
							v-for="(item, index) in listData"
							:key="index"
							:item="formatForOverview(item)"
							@click="handlePreview(item)"
						/>
					</div>
					<OverviewModuleFooter @click="handleModuleMore" />
				</div>
			</SurfStateBox>
		</div>
	</div>
</template>

<script setup>
import OverviewModuleTitle from '@rebuild/materials/shared/page_container/OverviewModuleTitle.vue';
import OverviewModuleFooter from '@rebuild/materials/shared/page_container/OverviewModuleFooter.vue';
import SurfStateBox from '@rebuild/materials/shared/common/surf/SurfStateBox.vue';
import SurfInlineTwoTextStyle1 from '@rebuild/materials/shared/common/surf/SurfInlineTwoTextStyle1.vue';
import { useNavigation } from '@rebuild/hooks/useNavigation';
import { onMounted, computed } from 'vue';
import { useSurfAnnouncement } from '@rebuild/materials/shared/announcement/surf/useSurfAnnouncement';
import { useRequestState } from '@rebuild/hooks/data/useRequestState';

const props = defineProps({
	name: {
		type: String,
		required: true
	},
	moduleId: {
		type: String,
		required: true
	}
});

const { announcementData, initConfig, loadAnnouncementData, formatForOverview, handlePreview, getFullTypeRange, isEmpty } =
	useSurfAnnouncement();
const { loading, completed, start, end } = useRequestState();

const listData = computed(() => {
	return announcementData.value;
});

const maxDisplayCount = 4;
const loadData = async () => {
	start();
	await initConfig();
	await loadAnnouncementData({
		pageStart: 0,
		pageNum: maxDisplayCount,
		classificationIds: getFullTypeRange()
	});
	end();
};

onMounted(() => {
	loadData();
});

const { viewPageInSurf } = useNavigation();
const handleModuleMore = () => {
	viewPageInSurf({
		module: { moduleId: props.moduleId }
	});
};
</script>

<style lang="less" scoped>
.announcement-overview {
	.overview-group {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}
}
</style>

